import Form from '@utils/form'
import Percentage from './components/percentage.vue'

export default new Form('performance.numberFormula')
  .url('/srmRationFormula/addSrmRationFormula', process.env.VUE_APP_PURCHASE_API)
  .title('formTitle.baseInfo')
  .add('rationFormulaNo').required()
  .add('rationFormulaName').required()
  .add('qualifiedBatchWeight').component(Percentage).required()
  .add('qualifiedReceiptWeight').merge('number').required()
  .add('expectedDeliveryWeight').merge('number').required()
  .add('committedDeliveryWeight').merge('number').required()
  .add('priceDifferenceWeight').merge('number').required()
  .add('toleranceDays').merge('number').required()
  .add('remarks').merge('textarea')
  .end()
